const GET_PRODUCTS = "GET_PRODUCTS";
export { GET_PRODUCTS}